export default {
  error: 'error',
  success: 'success',
};
